import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { Link } from 'redux-little-router';
import { Form, Affix, Timeline, Avatar, Tabs, Card, Modal, Divider, Button, Row, Col, Icon, Dropdown, Menu, Breadcrumb, List, Tag, Layout } from 'antd';
import CategoryCard from './CategoryCard';
import { CATEGORY_COLOR } from '../entityColors';
import categoryActions from './categoryActions';
import entityActions from '../../common/genericActions/entityActions';
import TabContentHeader from '../TabContentHeader';
import CategoryProps from './CategoryProps';
import tabHOC from '../tabHOC';

const mapStateToProps = (state, ownProps) => {
  const keyWindow = ownProps.keyWindow;
  const meta = R.path(['category', keyWindow], state);
  const id = R.path(['ids', 0], meta);
  const category = R.pathOr({}, ['category', 'byId', id], state);
  /*
  const draft = R.path(['category', 'draftsById', id], state);
  const derivedCategory = getDerivedCategory(category, draft);
  const revisions = getRevisions(category, draft);
  */
  return ({
    keyWindow,
    category,
    isNew: meta.isNew,
    isLoading: meta.isLoading,
    isEdit: meta.isEdit,
  });
};

const mapDispatchToProps = dispatch => ({
  onClose: keyWindow => dispatch(entityActions.releaseKeyWindow(keyWindow)),
  onDelete: (keyWindow, id) => {
    dispatch(categoryActions.removeCategory(keyWindow, id));
  },
  onSave: (keyWindow, id, data) => {
    dispatch(categoryActions.saveCategory(keyWindow, id, data));
  },
  onCreate: (keyWindow, id, data) => {
    dispatch(categoryActions.createCategory(keyWindow, id, data));
  },
  onEdit: (keyWindow, id) => {
    dispatch(categoryActions.editCategory(keyWindow, id));
  },
  onUndoEdit: (keyWindow, id) => {
    dispatch(categoryActions.undoEditCategory(keyWindow, id));
  },
});

/*
const onFieldsChange = ({ category, onEdit }, fields) => {
  onEdit(category.id, Object.keys(fields).reduce((acc, key) => ({ ...acc, [key]: fields[key].value }), {}));
};
*/

const queryKeys = ['query', 'version'];
const generalKeys = ['published', 'description', 'tags', 'notes'];

class Category extends React.Component {
  handleMenuAction = ({ key }) => {
    switch (key) {
      case 'delete':
        Modal.confirm({
          title: 'Are you sure you want to delete this category?',
          content: 'The effects of deleting a category are permanent. You will not be able to undo this action.',
          okText: 'Yes, delete category',
          okType: 'danger',
          onOk: this.handleDelete,
          cancelText: 'Cancel',
        });
        break;
      default:
    }
  };
  handleView = () => {
    this.setState({ mode: 'view' });
  };
  handleUndoEdit = () => {
    const { onUndoEdit, keyWindow, id } = this.props;
    onUndoEdit(keyWindow, id);
  };
  handleEdit = () => {
    const { onEdit, keyWindow, id } = this.props;
    onEdit(keyWindow, id);
  };
  handleDelete = () => {
    const { keyWindow, category, onDelete } = this.props;
    onDelete(keyWindow, category.id);
  };
  handleSave = () => {
    const { keyWindow, category, onSave, form } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        onSave(keyWindow, category.id, { ...category, ...values });
      }
    });
  };
  handleCreate = () => {
    const { keyWindow, category, onCreate, form } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        onCreate(keyWindow, values.name, { ...category, ...values, id: values.name });
      }
    });
  };
  handleClose = () => {
    const { onClose, keyWindow } = this.props;
    onClose(keyWindow);
  };
  * renderActions() {
    const { isNew, isEdit } = this.props;

    if (isNew) {
      yield (
        <Col key="label">Creating a new category</Col>
      );
      yield (
        <Col key="cancel">
          <Button onClick={this.handleClose}>Cancel</Button>
        </Col>
      );
    } else if (isEdit) {
      yield (
        <Col key="label">Editing</Col>
      );
      yield (
        <Col key="cancel">
          <Button onClick={this.handleUndoEdit}>Cancel</Button>
        </Col>
      );
    } else {
      const menu = (
        <Menu onClick={this.handleMenuAction}>
          {/*
        <Menu.Item key="deactivate">Deactivate</Menu.Item>
        <Menu.Item key="recategorize">Recategorize</Menu.Item>
        <Menu.Item key="remame">Rename</Menu.Item>
        */}
          <Menu.Item key="delete">Delete</Menu.Item>
        </Menu>
      );

      yield (
        <Col key="edit">
          <Button onClick={this.handleEdit}>Edit</Button>
        </Col>
      );
      yield (
        <Col key="actions">
          <Dropdown overlay={menu}>
            <Button>
              Actions <Icon type="down" />
            </Button>
          </Dropdown>
        </Col>
      );
    }
  }
  * renderFooterActions() {
    const { isLoading, isNew, isEdit } = this.props;

    if (isNew) {
      yield (
        <Col key="discard"><Button onClick={this.handleClose}>Cancel</Button></Col>
      );

      yield (
        <Col key="save"><Button loading={isLoading} onClick={this.handleCreate} type="primary">Save</Button></Col>
      );
    } else if (isEdit) {
      yield (
        <Col key="cancel"><Button onClick={this.handleUndoEdit}>Cancel</Button></Col>
      );
      yield (
        <Col key="save"><Button loading={isLoading} onClick={this.handleSave} type="primary">Save</Button></Col>
      );
    }
  }
  renderSubHeader() {
    const { isNew, category } = this.props;

    if (isNew) {
      return ([]);
    }

    return ([
      /*
      <Card.Meta
        avatar={<Avatar icon="database" />}
        key="location"
        title="VoiceBase"
        description="Saved to VBQL server"
      />,
      <Card.Meta
        avatar={<Avatar icon="poweroff" />}
        key="published"
        title={
          <span style={{ position: 'relative' }}>
            Status:
            <Tag
              color={category.published === 'active' ? 'green' : 'red'}
              style={{ position: 'absolute', marginLeft: '8px', left: '100%', top: '50%', transform: 'translateY(-50%)' }}
            >
              {category.published === 'active' ? 'active' : 'inactive'}
            </Tag>
          </span>
        }
        description="Categorizing new media"
      />,
      */
      <Card.Meta
        avatar={<Avatar icon="calendar" />}
        key="history"
        description={
          <Row type="flex" style={{ flexDirection: 'column', height: '100%' }} justify="space-between">
            <Col style={{ verticalAlign: 'middle' }}>
              <span style={{ fontSize: '16px', fontWeight: '500', color: 'rgba(0, 0, 0, 0.85)' }}>Updated</span>: {category.lastModified}
            </Col>
            <Col style={{ verticalAlign: 'middle' }}>
              <span style={{ fontSize: '16px', fontWeight: '500', color: 'rgba(0, 0, 0, 0.85)' }}>Created</span>: {category.created}
            </Col>
          </Row>
        }
      />,
    ]);
  }
  renderBody() {
    const { isNew, category, isEdit, isLoading, form } = this.props;

    if (isNew) {
      return (
        <div style={{ margin: '0 auto', width: '800px' }}>
          <Card>
            <CategoryProps form={form} category={category} mode="add" keys={['name']} />
          </Card>
          <Card style={{ marginTop: '8px' }}>
            <CategoryProps form={form} category={category} mode="add" keys={['published', 'description', 'tags']} />
          </Card>
          <Card style={{ marginTop: '8px' }}>
            <CategoryProps form={form} category={category} mode="add" keys={['query', 'version']} />
          </Card>
          <Card style={{ marginTop: '8px' }}>
            <CategoryProps form={form} category={category} mode="add" keys={['notes']} />
          </Card>
        </div>
      );
    }

    return (
      <Row type="flex" gutter={32}>
        <Col lg={8} md={12} sm={24} style={{ marginBottom: '32px' }}>
          <Card
            bordered={false}
            loading={isLoading && !isEdit}
            title={
              <div>
                <span style={{ marginRight: '16px' }}><Avatar icon="profile" /></span>
                Basic Info
              </div>
            }
          >
            <CategoryProps
              form={form}
              mode={isEdit ? 'edit' : 'view'}
              category={category}
              keys={['published', 'description', 'tags', 'version', 'notes', 'created', 'lastModified']}
            />
          </Card>
        </Col>
        <Col lg={16} md={12} sm={24} style={{ marginBottom: '32px' }}>
          <Card
            bordered={false}
            loading={isLoading && !isEdit}
            title={
              <div>
                <span style={{ marginRight: '16px' }}><Avatar icon="code-o" /></span>
                Query
              </div>
            }
          >
            <CategoryProps
              form={form}
              mode={isEdit ? 'edit' : 'view'}
              category={category}
              keys={['query']}
            />
          </Card>
        </Col>
      </Row>
    );
  }

  render() {
    const { category, isNew, isLoading } = this.props;
    const footerActions = [...this.renderFooterActions()];

    if (!category) return (<div>Loading</div>);
    return (
      <div style={{ minHeight: '100vh' }}>
        <TabContentHeader
          title={isNew ? 'New Category' : category.id}
          icon="inbox"
          color={CATEGORY_COLOR}
          loading={isLoading}
          actions={<Row type="flex" gutter={8}>{[...this.renderActions()]}</Row>}
        />
        <div style={{ padding: '32px' }}>
          {this.renderBody()}
        </div>
        {!!footerActions.length &&
        <Row
          type="flex"
          align="end"
          justify="middle"
          gutter={8}
          style={{
            boxShadow: '0 -2px 2px -2px #e0e0e0',
            zIndex: '1',
            position: 'sticky',
            bottom: '0',
            background: '#fff',
            padding: '16px 32px',
          }}
        >
          {footerActions}
        </Row>
        }
      </div>
    );
  }

}

export default tabHOC('category')(
  connect(mapStateToProps, mapDispatchToProps)(
    Form.create()(Category),
  ),
);
